module.exports = __webpack_public_path__ + "img/tg.15880e0b.svg";